module.exports = __webpack_public_path__ + "media/1B_ExplorationDrilling.1a20de56.mp4";